<template>
	<span>
		I am an Associate Professor at the School of Software Technology, Zhejiang University, China. I am very fortunate to work under the supervision of <a href="https://person.zju.edu.cn/en/xiaohu">Prof. Xiaohu Yang</a>.
		<br/>
		<br/>
		I got my Ph.D. degree in June 2020 from the Department of Computer Science and Technology, Nanjing University, China. My
		advisor is <a href="https://isetnju.github.io/guq/index.html">Prof. Qing Gu</a>. From October 2018 to October 2019, I was a visiting student at Monash University.
		<br/>
				<br/>
		To help developers and testers improve their productivity, my current research focuses on mining and analyzing
		rich data in software repositories to uncover interesting and actionable information. I have employed and customized
		structured and unstructured data analytics techniques, including data mining, information retrieval, natural
		language processing, search-based algorithms, and program analysis to transform passive software engineering data
		into automated tools and new insights.
	</span>
</template>
<script>
export default {

}
</script>
<style lang="">
	
</style>